<template>
 <div>
   <b-row>
    <b-col md="1">
    </b-col>
    <b-col md="10">
      <b-card md="1" bg-variant="none"> {{description}}</b-card>
    </b-col>
    <b-col md="1">
    </b-col>
   </b-row>
   <br>
    <b-row>
      <b-col md="1">
      </b-col>
      <b-col md="10">
        <div v-if="ams_data">
          <asset-image-link-card :data_item="ams_data" :image_item="dataImage(ams_data)" :product_item="dataProduct(ams_data)"></asset-image-link-card>
        </div>
      </b-col>
      <b-col md="1">
        <data-navagations
          :can_update="isAdminPath"
          @update="doUpdate"
          @cancel="doCancel"
          @help="doHelp"
        ></data-navagations>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import {ADMIN_PATH, ITEM_IMAGE_ASSOCIATIONS, COLLECTION_IMAGES, PRODUCT_ITEMS, amsApiResourcePath} from '@/ams_route.js'
import AssetImageLinkCard from './AssetImageLinkCard.vue'
import DataNavagations from './DataNavagations.vue'
import {amsSchema} from '@/schema'
import {belongsToDescription} from '@/utils'

export default {
  components: {
    AssetImageLinkCard,
    DataNavagations
  },
  props: {
    id: {
      Type: String
    },
    api_path: {
      Type: String
    }
  },
  data () {
    return {
      ams_type: ITEM_IMAGE_ASSOCIATIONS,
      ams_data: undefined,
      description: '',
      included: undefined
    }
  },
  computed: {
    isAdminPath() {
      return this.apiPath() == ADMIN_PATH
    }
  },
  methods: {
    dataImage(item) {
      let included_obj = this.included.find( 
        el =>  
        el.type === COLLECTION_IMAGES && el.id === item.attributes['collection-image-id']
      )
      return included_obj
    },
    dataProduct(item) {
      let included_obj = this.included.find( 
        el =>  
        el.type === PRODUCT_ITEMS && el.id === item.attributes['product-item-id']
      )
      return included_obj
    },
    apiPath () {
      return this.paramApiPath() || ADMIN_PATH
    },
    paramApiPath() {
      // Note $route and $router are not the same
      return this.api_path || this.$route.query?.api_path
    },
    apiResourcePath() {
      return amsApiResourcePath(this.apiPath(), ITEM_IMAGE_ASSOCIATIONS) + '/' + this.id
    },
    doCancel() {
      this.$router.go(-1)
    },
    doUpdate() {
      this.$router.push( {path: '/asset-image-link/' + this.id + '/update'})
    },
    doHelp() {
      this.$router.push( {path: '/references/ProductItem/information/' + this.ams_data.attributes['product-item-id']})
    }
  },
  mounted () {
    let schema_obj = amsSchema.find( 
      el =>  
      el.type === this.ams_type
    )
    http_v1.get(this.apiResourcePath(), {
    }).then(response => {
      if( response.data) {
        this.ams_data = response.data.data
        this.included = response.data.included
        this.description = belongsToDescription(
          response.data.data, response.data.included, schema_obj.describe_belongs_to
        )
      }
    }).catch(error => {
      if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      }
    )
  }
}
</script>
